import { render, staticRenderFns } from "./SecurityLayout.vue?vue&type=template&id=2c2f3f09&scoped=true&"
import script from "./SecurityLayout.vue?vue&type=script&lang=js&"
export * from "./SecurityLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2f3f09",
  null
  
)

export default component.exports